const AuthLoading = () => {
    return <div>Signing you in...</div>;
};

const AuthError = ({ error }) => {
    return (
        <div>
            <h1>Authentication Error</h1>
            <p>{error?.message ?? "Unable to sign you in."}</p>
        </div>
    );
};

export { AuthLoading, AuthError };
